import { THeaders, postFetch, getFetch, deleteFetch } from "../requests/request-methods";

type THttpOptions = {
  body?: unknown;
  headers?: THeaders;
};

type TServiceBaseConfig = {
  url: string;
  subscriptionKey?: string;
};

class ServiceHelper {
  baseUrl: string = "";
  subscriptionKey?: string = undefined;

  setBaseUrl(url: string) {
    this.baseUrl = url;
  }

  setBaseConfig(options: TServiceBaseConfig) {
    this.baseUrl = options.url;
    this.subscriptionKey = options.subscriptionKey;
  }

  async httpPost(path: string, options?: THttpOptions) {
    const headers = options?.headers || ({} satisfies THeaders);

    headers["Ocp-Apim-Subscription-Key"] = this.subscriptionKey;
    return postFetch(this.baseUrl + path, options?.body, headers);
  }

  async httpGet(path: string, options?: THttpOptions) {
    const headers = options?.headers || ({} satisfies THeaders);
    headers["Ocp-Apim-Subscription-Key"] = this.subscriptionKey;
    return getFetch(this.baseUrl + path, headers);
  }

  async httpDelete(path: string, options?: THttpOptions) {
    const headers = options?.headers || ({} satisfies THeaders);
    headers["Ocp-Apim-Subscription-Key"] = this.subscriptionKey;
    return deleteFetch(this.baseUrl + path, headers);
  }
}

export default new ServiceHelper();
